import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      UPCOMING: "KLAR TIL LEVERING",
      CONFIRM_DELIVERY: "BEKREFT LEVERING",
      PAUSED: "UKE PAUSET",
      SUBSCRIPTION_CANCELLED: "ABONNEMENT AVSLUTTET",
      ERROR_NOTIFICATION:
        "Noe gikk galt ved endring av levering, kontakt kundeservice,",
      TO_BOOK_ON_WEEK: "For å bestille middager til leveringsuke",
      CUSTOMER_SERVICE_WILL_HELP:
        "vil kundeservice hjelpe deg. En chat åpnes nå :)",
      PREPOPULATED_MESSAGE: (week: number) =>
        `Hei! Jeg vil gjerne endre startdato og flytte frem min første levering til uke ${week}`,
      SUBJECT_OF_INTERCOME_MESSAGE: "Endre startdato for levering",
      DELIVERY_DETAILS: "Endre leveringsdetaljer",
      CHANGE_DELIVERY_DETAILS: "Endre leveringsdetaljer",
      MAKE_CHANGES_BY: "Endre innen",
      BOOK_BY: "Bestill innen",
      TIME_PREFIX: "",
      TO: "til",
      DELIVERY_TIME_ADJUSTED: "Ditt leveringstidspunkt er endret",
      ORDER_DELIVERY: "Velg levering",
      MANAGE_DELIVERY: "Endre levering",
    },

    se: {
      UPCOMING: "KLART FÖR LEVERANS",
      CONFIRM_DELIVERY: "BEKRÄFTA LEVERANS",
      PAUSED: "VECKAN PAUSAD",
      SUBSCRIPTION_CANCELLED: "ABONNEMANG AVSLUTAT",
      ERROR_NOTIFICATION:
        "Något gick fel vid ändring av leverans, kontakta kundtjänst,",
      TO_BOOK_ON_WEEK: "För att boka på leverans v.",
      CUSTOMER_SERVICE_WILL_HELP:
        "hjälper kundtjänst dig, en chattruta öppnas nu :)",
      PREPOPULATED_MESSAGE: (week: number) =>
        `Hej, jag skulle vilja ändra mitt startdatum och flytta fram min första leverans till vecka  ${week}`,
      SUBJECT_OF_INTERCOME_MESSAGE: "Ändra startdatum for leverans",
      DELIVERY_DETAILS: "Ändra leveransdetaljer",
      CHANGE_DELIVERY_DETAILS: "Ändra leveransdetaljer",
      MAKE_CHANGES_BY: "Ändra senast",
      BOOK_BY: "Beställ senast",
      TIME_PREFIX: "",
      TO: "till",
      DELIVERY_TIME_ADJUSTED: "Din leveranstid har blivit justerad",
      ORDER_DELIVERY: "Boka leverans",
      MANAGE_DELIVERY: "Hantera leverans",
    },

    dk: {
      UPCOMING: "KLAR TIL LEVERING",
      CONFIRM_DELIVERY: "BEKRÆFT LEVERING",
      SUBSCRIPTION_CANCELLED: "ABONNEMENT AFMELDT",
      PAUSED: "UGE PAUSET",
      ERROR_NOTIFICATION:
        "Noget gik galt ved ændring af levering, kontakt kundeservice,",
      TO_BOOK_ON_WEEK: "For at bestille en måltidskasse til leveringsuge",
      CUSTOMER_SERVICE_WILL_HELP:
        "vil kundeservice hjælpe dig. En chat åbnes nu :)",
      PREPOPULATED_MESSAGE: (week: number) =>
        `Hej. Jeg vil gerne ændre min startdato og flytte min første levering frem til  uge ${week} .`,
      SUBJECT_OF_INTERCOME_MESSAGE: "Ændr startdato for levering",
      DELIVERY_DETAILS: "Tilpas leveringsdetaljer",
      CHANGE_DELIVERY_DETAILS: "Skift leveringsoplysninger",
      MAKE_CHANGES_BY: "Foretag ændringer senest",
      BOOK_BY: "Bestil senest",
      TIME_PREFIX: "kl.",
      TO: "til",
      DELIVERY_TIME_ADJUSTED: "Leveringstidspunkt ændret",
      ORDER_DELIVERY: "Aktivér",
      MANAGE_DELIVERY: "Tilpas levering",
    },
  } as const
)[language];
